import _ from 'lodash'
import { login, logout, getInfo, updateInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  user: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER: (state, user) => {
    state.user = user
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { email, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ email: email.trim(), password: password }).then(response => {
        commit('SET_TOKEN', response.data.access_token)
        setToken(response.data.access_token)
        resolve()
      }).catch(reject)
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const data = response.data.user

        if (!data) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('Đăng nhập thất bại. Vui long thử lại')
        }

        // roles must be a non-empty array
        // if (!roles || roles.length <= 0) {
        //   reject('getInfo: roles must be a non-null array!')
        // }

        commit('SET_USER', data)
        resolve(data)
      }).catch(reject)
    })
  },

  updateInfo({ commit }, data) {
    return new Promise((resolve, reject) => {
      const update = _.pick(data, [
        'phone', 'fullname', 'job_titles', 'about', 'contact'
      ])
      updateInfo(update).then(response => {
        commit('SET_USER', data)
        resolve()
      }).catch(reject)
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USER', '')
        removeToken()
        resolve()
      }).catch(reject)
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_USER', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
